import { render, staticRenderFns } from "./image-type-switch.vue?vue&type=template&id=5f3c751c&scoped=true"
import script from "./image-type-switch.vue?vue&type=script&lang=js"
export * from "./image-type-switch.vue?vue&type=script&lang=js"
import style0 from "./image-type-switch.vue?vue&type=style&index=0&id=5f3c751c&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_css-load_72a858df71aeaca8538e59a65db64572/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5f3c751c",
  null
  
)

export default component.exports